import { Box, Typography } from "@mui/material";
import useColors from "../../../../../../../api/hooks/useColors";

const VulnerabilitySLAChartLegend = ({ series }) => {
  const colors = useColors();
  const seriesToStack = {};

  // Group series by stack
  series.forEach((item) => {
    if (seriesToStack[item.stackLabel]) {
      seriesToStack[item.stackLabel].push(item);
    } else {
      seriesToStack[item.stackLabel] = [item];
    }
  });

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
        gap: 1,
        minWidth: "150px",
      }}
    >
      {/* Map through stacks - Object.entries returns [key, value] pairs */}
      {Object.entries(seriesToStack).map(([stack, items]) => (
        <Box
          key={`stack-${stack}`}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            alignItems: "flex-start",
            color: colors.text_secondary,
          }}
        >
          <Typography variant="caption" color={colors.text_primary}>
            {stack}
          </Typography>
          {Array.isArray(items) &&
            items.map((item) => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    width: "10px",
                    height: "10px",
                    background: item.color,
                    borderRadius: "3px",
                  }}
                />
                <Typography variant="caption">{item.label}</Typography>
              </Box>
            ))}
        </Box>
      ))}
    </Box>
  );
};

export default VulnerabilitySLAChartLegend;
